import { render, staticRenderFns } from "./productCistanche.vue?vue&type=template&id=2485b152&scoped=true"
import script from "./productCistanche.vue?vue&type=script&lang=js"
export * from "./productCistanche.vue?vue&type=script&lang=js"
import style0 from "./productCistanche.vue?vue&type=style&index=0&id=2485b152&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2485b152",
  null
  
)

export default component.exports